import { BusinessIcon, Label, SelectionList } from '@postidigital/posti-components'
import { observer } from 'mobx-react-lite'
import React, { useContext, useEffect } from 'react'
import styled, { css } from 'styled-components'

import { StoreContext } from '../../store'
import { ViewLoading } from '../general/ViewLoading'

const StyledSelectionList = styled(SelectionList)(
  ({
    theme: {
      color: {
        border: {
          accent: { lowContrast },
        },
      },
      spacing,
    },
  }) => css`
    div[role='group'] {
      display: flex;
      flex-direction: column;
      gap: ${spacing.space6}rem;
    }

    div[role='group'] > div {
      width: 100%;
    }

    div[role='group'] > div > div {
      display: flex !important;
      align-items: center;
      gap: ${spacing.space3}rem;
      padding: ${spacing.space3}rem ${spacing.space5}rem;
      background-color: transparent !important;
      border: 0 !important;
      border-bottom: 1px solid #e5e5e5 !important;
      border-radius: 0 !important;
      box-shadow: none !important;

      &:has(> input:focus-visible) {
        outline: none !important;
        box-shadow: ${lowContrast.default} 0 0 0 3px inset !important;
      }

      > input + div {
        order: 3;
        margin-left: auto;
      }

      > svg {
        order: 1;
      }

      > div:last-of-type {
        order: 2;
      }
    }
  `
)

export const SelectOrganisationComponent: React.FC = () => {
  const { userStore, inviteStore } = useContext(StoreContext)
  const { user } = userStore
  const { organizations } = user || {}

  const { setSelectedBusiness, selectedBusiness } = inviteStore

  useEffect(() => {
    if (organizations && organizations.length === 1) {
      const name = organizations[0].name
      const businessId = organizations[0].businessId
      setSelectedBusiness({ name, businessId })
    }
  }, [organizations, setSelectedBusiness])

  if (userStore.isLoading) {
    return <ViewLoading />
  }

  return (
    <StyledSelectionList title="Organizations">
      <SelectionList.Group>
        {organizations.map(({ businessId, name }) => {
          const isSelected = businessId === selectedBusiness.businessId || organizations.length === 1

          return (
            <SelectionList.Item
              key={businessId}
              hasIcon
              icon={BusinessIcon}
              name="organization"
              selected={isSelected}
              value={businessId}
              onChange={() => setSelectedBusiness({ name, businessId })}
            >
              <Label size="Three">{name}</Label>
            </SelectionList.Item>
          )
        })}
      </SelectionList.Group>
    </StyledSelectionList>
  )
}

export const SelectOrganisationList = observer(SelectOrganisationComponent)
